// Author thq
// Date 2024-02-21 10:33:26

class TpmMonitorProgramStatusTmo {
    constructor({
                    id = null,
                    nodeId = '',
                    tmoCodeBda = '',
                    tmoStatus = '',
                    tmoBeginTime = '',
                    tmoEndTime = '',
                    tmoDurationTime = '',
                    tmoStartValue = '',
                    tmoEndValue = ''
                }
                    = {}) {
        this.id = id;
        this.nodeId = nodeId;
        this.tmoCodeBda = tmoCodeBda;
        this.tmoStatus = tmoStatus;
        this.tmoBeginTime = tmoBeginTime;
        this.tmoEndTime = tmoEndTime;
        this.tmoDurationTime = tmoDurationTime;
        this.tmoStartValue = tmoStartValue;
        this.tmoEndValue = tmoEndValue;
    }
}

function newEntity() {
    return new TpmMonitorProgramStatusTmo();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeId',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.nodeId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoCodeBda',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoStatus',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoBeginTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoEndTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoDurationTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoDurationTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoStartValue',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoStartValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoEndValue',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.tmoEndValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nodeIdFilter: '',
    tmoCodeBdaFilter: '',
    tmoStatusFilter: '',
    tmoBeginTimeRteFilter: '',
    tmoBeginTimeLteFilter: '',
    tmoEndTimeRteFilter: '',
    tmoEndTimeLteFilter: '',
    tmoEndTimeIsNullFilter: '',
    tmoEndTimeRteQueryStartTimeFilter: '',
    tmoBeginTimeLteQueryEndTimeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nodeIdFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.nodeId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoCodeBdaFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStatusFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoBeginTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoBeginTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.filter.tmoEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'nodeId',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.nodeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoCodeBda',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStatus',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoDurationTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoDurationTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStartValue',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoStartValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndValue',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmo.entity.tmoEndValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmMonitorProgramStatusTmo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
